export default "__VITE_ASSET__02VkNMkE__"